import {ValueObject} from '@s-ui/domain'

import {PriceDropValueObject} from '../../ads/ValueObjects/PriceDropValueObject.js'

export class FilterPriceDropDataSearchValueObject extends ValueObject {
  #priceDrop

  constructor({priceDrop} = {}) {
    super()
    this.#priceDrop = priceDrop ?? null
  }

  static createWithDefault() {
    return new this({priceDrop: null})
  }

  static create() {
    return new this({priceDrop: this.#buildDefaultPriceDrop()})
  }

  static #buildDefaultPriceDrop() {
    const {
      PRICE_DROP_MIN_VALID_PERCENTAGE: minPct,
      PRICE_DROP_MAX_VALID_PERCENTAGE: maxPct,
      PRICE_DROP_VALID_DAYS: validDays,
      ONE_DAY_IN_MS: dayMs
    } = PriceDropValueObject

    const now = Date.now()
    const startMs = now - (validDays - 1) * dayMs

    return {
      percentage: {from: minPct, to: maxPct},
      date: {
        from: new Date(startMs).toISOString(),
        to: new Date(now).toISOString()
      }
    }
  }

  get isEmpty() {
    return this.#priceDrop == null // true for null or undefined
  }

  get value() {
    return this.#priceDrop
  }

  toJSON() {
    return {priceDrop: this.#priceDrop}
  }
}
